"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MarketplaceIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 11h2v5H4zm.56-7.11C4.8 3.4 5.45 3 6.01 3H18c.56 0 1.21.4 1.45.89L21 7H3zM3 7h18v1H3zm15 4h2v5h-2zM3 8c.14 1.13 1.09 2 2.25 2s2.11-.87 2.25-2zm4.5 0c.14 1.13 1.09 2 2.25 2s2.11-.87 2.25-2zM12 8c.14 1.13 1.09 2 2.25 2s2.11-.87 2.25-2zm4.5 0c.14 1.13 1.09 2 2.25 2s2.11-.87 2.25-2zM4 16h16v3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 19z"/></svg>`
}, props));
MarketplaceIcon.displayName = 'MarketplaceIcon';
var _default = exports.default = MarketplaceIcon;